export const QuoteStatuses = {
  DRAFT: 'DRAFT',
  READY: 'READY',
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;

export type QuoteStatus = (typeof QuoteStatuses)[keyof typeof QuoteStatuses];
